/* Aaina Atelier — theme interactions */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  document.addEventListener('DOMContentLoaded', function(){
    /* transparent header -> solid on scroll (home) */
    var topEl=document.getElementById('top');
    if(topEl){
      var isHome=document.body.classList.contains('template-index');
      var lastScroll=window.scrollY, tick=false;
      var upd=function(){
        var y=Math.max(window.scrollY,0), delta=y-lastScroll;
        topEl.classList.toggle('scrolled',y>24);
        if(y<70){
          topEl.classList.remove('nav-hidden');
        } else if(delta>1 && y>140 && !document.body.classList.contains('drawer-open')){
          topEl.classList.add('nav-hidden');
        } else if(delta<-1){
          topEl.classList.remove('nav-hidden');
        }
        lastScroll=y;tick=false;
      };
      if(!isHome) topEl.classList.add('scrolled');
      upd();
      addEventListener('scroll',function(){if(!tick){requestAnimationFrame(upd);tick=true;}},{passive:true});
    }

    /* top bar rotator */
    var msgs=document.querySelectorAll('.topbar .msg'), mi=0;
    if(msgs.length>1 && !reduce){ setInterval(function(){ msgs[mi].classList.remove('on'); mi=(mi+1)%msgs.length; msgs[mi].classList.add('on'); },4000); }

    /* hero slider */
    document.querySelectorAll('[data-slider]').forEach(function(hero){
      var track=hero.querySelector('.slides'); if(!track) return;
      var n=track.children.length, idx=0;
      var dots=hero.querySelector('[data-dots]');
      if(dots){ for(var i=0;i<n;i++){ var d=document.createElement('i'); if(i===0)d.className='on'; d.dataset.i=i; dots.appendChild(d); } }
      function go(i){ idx=(i+n)%n; track.style.transform='translateX(-'+(idx*100)+'%)'; if(dots) dots.querySelectorAll('i').forEach(function(x,j){ x.classList.toggle('on',j===idx); }); }
      var next=hero.querySelector('[data-next]'), prev=hero.querySelector('[data-prev]');
      if(next) next.onclick=function(){ go(idx+1); };
      if(prev) prev.onclick=function(){ go(idx-1); };
      if(dots) dots.addEventListener('click',function(e){ if(e.target.dataset.i!==undefined) go(+e.target.dataset.i); });
       if(n>1 && !reduce){ var auto=setInterval(function(){ go(idx+1); },6000); track.addEventListener('pointerdown',function(){ clearInterval(auto); }); }
    });

    /* trending tabs */
    document.querySelectorAll('[data-tabs-wrap]').forEach(function(wrap){
      var btns=wrap.querySelectorAll('.tabs button');
      var panels=wrap.querySelectorAll('.tab-panel');
      btns.forEach(function(b){ b.onclick=function(){
        btns.forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        btns.forEach(function(x){ x.setAttribute('aria-selected', x===b ? 'true' : 'false'); });
        panels.forEach(function(p){ p.hidden = (p.dataset.panel !== b.dataset.t); });
      }; });
    });

    /* reveal */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } }); },{threshold:.08});
      document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
    } else { document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); }); }

    /* related carousels */
    document.querySelectorAll('[data-caro]').forEach(function(c){
      var wrap=c.closest('[data-caro-wrap]')||document;
      var next=wrap.querySelector('[data-next]'), prev=wrap.querySelector('[data-prev]');
      var step=function(){ return Math.min(c.clientWidth*0.8,340); };
      if(next) next.onclick=function(){ c.scrollBy({left:step(),behavior:'smooth'}); };
      if(prev) prev.onclick=function(){ c.scrollBy({left:-step(),behavior:'smooth'}); };
      var down=false,sx,sl;
      c.addEventListener('pointerdown',function(e){ down=true; c.classList.add('drag'); sx=e.pageX; sl=c.scrollLeft; });
      addEventListener('pointerup',function(){ down=false; c.classList.remove('drag'); });
      c.addEventListener('pointermove',function(e){ if(down){ c.scrollLeft=sl-(e.pageX-sx); } });
    });

    /* drawer */
    var dr=document.querySelector('.drawer'), sc=document.querySelector('.scrim'), bg=document.querySelector('.burger'), dx=document.querySelector('.drawer .x');
    var lastFocus=null;
    var oD=function(){ lastFocus=document.activeElement; if(topEl)topEl.classList.remove('nav-hidden'); if(dr){dr.classList.add('open');dr.setAttribute('aria-hidden','false');} if(sc){sc.hidden=false;sc.classList.add('open');} if(bg)bg.setAttribute('aria-expanded','true'); document.body.classList.add('drawer-open'); if(dx)dx.focus(); };
    var cD=function(){ if(dr){dr.classList.remove('open');dr.setAttribute('aria-hidden','true');} if(sc){sc.classList.remove('open');sc.hidden=true;} if(bg)bg.setAttribute('aria-expanded','false'); document.body.classList.remove('drawer-open'); if(lastFocus)lastFocus.focus(); };
    if(bg) bg.onclick=oD; if(dx) dx.onclick=cD; if(sc) sc.onclick=cD;
    if(dr) dr.querySelectorAll('a').forEach(function(a){ a.onclick=cD; });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && dr && dr.classList.contains('open')) cD(); });

    /* PDP gallery */
    var mainImg=document.querySelector('[data-pdp-main]');
    if(mainImg){ document.querySelectorAll('[data-pdp-thumb]').forEach(function(t){ t.addEventListener('click',function(){ mainImg.src=t.dataset.full||t.src; }); }); }

    /* product variant selection */
    var productForm=document.querySelector('[data-product-form]');
    if(productForm){
      var variantData=productForm.querySelector('[data-variant-json]');
      var variantId=productForm.querySelector('[data-variant-id]');
      var priceEl=document.querySelector('[data-price]');
      var addBtn=productForm.querySelector('[data-add-btn]');
      var statusEl=productForm.querySelector('[data-variant-status]');
      var variants=variantData ? JSON.parse(variantData.textContent) : [];
      var moneyFormat=productForm.dataset.moneyFormat || 'Rs.{{amount}}';
      var money=function(cents){
        var amount=(cents/100).toLocaleString('en-PK',{minimumFractionDigits:2,maximumFractionDigits:2});
        return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/,amount);
      };
      var updateVariant=function(){
        var chosen=[];
        productForm.querySelectorAll('[data-option-position]:checked').forEach(function(input){ chosen[Number(input.dataset.optionPosition)-1]=input.value; });
        var variant=variants.find(function(v){ return v.options.every(function(option,i){ return option===chosen[i]; }); });
        productForm.querySelectorAll('.vals label').forEach(function(label){ var input=label.querySelector('input'); label.classList.toggle('sel',!!input.checked); });
        if(!variant){ variantId.value=''; addBtn.disabled=true; addBtn.textContent='Unavailable'; if(statusEl)statusEl.textContent='This combination is unavailable.'; return; }
        variantId.value=variant.id;
        addBtn.disabled=!variant.available;
        addBtn.textContent=variant.available ? 'Add to bag' : 'Sold out';
        if(priceEl){ priceEl.innerHTML=variant.compare_at_price>variant.price ? '<s>'+money(variant.compare_at_price)+'</s><span class="now">'+money(variant.price)+'</span>' : money(variant.price); }
        if(variant.featured_image && mainImg){ mainImg.src=variant.featured_image.src; }
        if(statusEl)statusEl.textContent=variant.available ? 'Selected '+variant.title+'.' : variant.title+' is sold out.';
        if(history.replaceState) history.replaceState({},'',location.pathname+'?variant='+variant.id);
      };
      productForm.querySelectorAll('[data-option-position]').forEach(function(input){ input.addEventListener('change',updateVariant); });
      updateVariant();
    }

    /* qty steppers */
    document.querySelectorAll('[data-qty]').forEach(function(q){
      var input=q.querySelector('input');
      q.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click',function(){ var v=parseInt(input.value||'1',10); v += (btn.dataset.step==='up'?1:-1); if(v<1)v=1; input.value=v; if(input.dataset.autosubmit!==undefined && input.form) input.form.submit(); });
      });
    });
  });
})();
